import React from 'react'
import { EmptyContent } from '@ztechapps/webui.util'

export const TaskListEmptyContent = () => {
  return (
    <EmptyContent
      icon="filter"
      message="No tasks match your filters"
      subMessage="Try adjusting your filters or clearing them to see all tasks."
    />
  )
}
